/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LogoutInput = {
  readonly customerId: string | number;
};

export type LogoutCustomerMutationVariables = Exact<{
  input: Types.LogoutInput;
}>;

export type LogoutCustomerMutation = {
  readonly logout:
    | { readonly __typename: 'LogoutSuccess' }
    | { readonly __typename: 'ValidationError' };
};

export const LogoutCustomerDocument = gql`
  mutation LogoutCustomer($input: LogoutInput!) {
    logout(input: $input) {
      __typename
    }
  }
`;

export function useLogoutCustomerMutation() {
  return Urql.useMutation<LogoutCustomerMutation, LogoutCustomerMutationVariables>(
    LogoutCustomerDocument,
  );
}
